"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@/common/errors");
function default_1({ error, confirm, onSellerPublishAgreeError, }) {
    var _a, _b, _c, _d, _e;
    const errorMsg = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.error_msg;
    const errorCode = (_e = (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.meta) === null || _e === void 0 ? void 0 : _e.alert_type;
    switch (errorMsg) {
        case 'ALREADY_COMPANY_SELLER_PUBLISH_AGREE_ERROR':
            onSellerPublishAgreeError.alreadyAgree();
            break;
        case 'REQUIRED_COMPANY_NUMBER_ERROR':
        case 'REQUIRED_COMPANY_POST_CODE_ERROR':
            onSellerPublishAgreeError.requireCompany();
            break;
        default:
            (0, errors_1.commonErrorConfirm)({
                confirm,
                errorCode,
                errorReason: errorMsg,
            });
    }
}
exports.default = default_1;
